import { Drawer } from 'syngenta-digital-cropwise-react-ui-kit';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuOutlined } from '@ant-design/icons';
import baseLogoImg from 'assets/images/cropwise-logo.svg';
import './styles.less';
import { LanguageDropdown } from 'pages/main-container/LanguageDropdown';
import { useMediaQuery } from 'react-responsive';
import { LocationOfResidenceDropdownComponent } from 'components/LocationOfResidenceDropdown';
import { getBrandLogo, getBrandName } from 'utils/BrandingUtils';
import { translationWrapper } from 'utils/common-methods';
import LegalDocumentsOptionsComponent  from 'components/LegalDocumentsOptions';
import { AvailableDocumentTypes } from 'utils/enums';

interface LegalDocumentsNavBarPropsComponent {
  defaultCountry: string;
  redirectToCurrentCountryLegalDocsScreen: any;
  setDocumentTypeSelected: any;
  documentTypeSelected: string;
  currentCountry: string;
}

const LegalDocumentsNavBar: React.FC<LegalDocumentsNavBarPropsComponent> = ({
    redirectToCurrentCountryLegalDocsScreen,
    documentTypeSelected,
    setDocumentTypeSelected,
    currentCountry,
  },
) => {

  const { t } = translationWrapper(useTranslation());
  const isDesktopOrLaptop = useMediaQuery({ minDeviceWidth: 1224 });
  const [mobileDrawerVisible, setMobileDrawerVisible] = useState<boolean>(false);



  const onCountrySelect = (value: string) => {
    redirectToCurrentCountryLegalDocsScreen(value);
  };

  const onTermsClicked = () => {
    setDocumentTypeSelected(AvailableDocumentTypes.TERMS);
    if (!isDesktopOrLaptop) {
      setMobileDrawerVisible(false);
    }
  };

  const onPrivacyClicked = () => {
    setDocumentTypeSelected(AvailableDocumentTypes.PRIVACY);
    if (!isDesktopOrLaptop) {
      setMobileDrawerVisible(false);
    }
  };

  return (
    <>
      {
        isDesktopOrLaptop ?
        <div className="legaldocs__sidebar">
          <div className="legaldocs__sidebar__first-layer">
            <img className="legal-docs-brand-logo" src={getBrandLogo()} alt={getBrandName()}/>
            <p className="legal-documents-title">{t('legal_documents')}</p>
            <LegalDocumentsOptionsComponent
              currentCountry={currentCountry}
              documentTypeSelected={documentTypeSelected}
              onTermsClicked={onTermsClicked}
              onPrivacyClicked={onPrivacyClicked}
              t={t}
            />
            <LocationOfResidenceDropdownComponent
              t={t}
              onCountrySelect={onCountrySelect}
              currentCountry={currentCountry}
            />
          </div>
          <div className='legaldocs-language-dropdown'>
            <LanguageDropdown hideTitleWhenSelectedLang={true}/>
          </div>
        </div>
          :
        <div className='legaldocs-sidebar-mobile'>
          <div className='sidebar-mobile-drawer-icon' onClick={() => setMobileDrawerVisible(true)}>
            <MenuOutlined />
          </div>
          <Drawer
            className="sidebar-mobile-drawer-container"
            visible={mobileDrawerVisible}
            placement={'left'}
            closable={true}
            onClose={() => setMobileDrawerVisible(false)}
          >
            <img style={{ marginLeft: '20px' }} src={baseLogoImg} />
            <div style={{height: '82%'}}>
              <LegalDocumentsOptionsComponent
                currentCountry={currentCountry}
                documentTypeSelected={documentTypeSelected}
                onTermsClicked={onTermsClicked}
                onPrivacyClicked={onPrivacyClicked}
                t={t}
              />
            </div>
            <div className='legaldocs-language-dropdown'>
              <LanguageDropdown hideTitleWhenSelectedLang={true}/>
            </div>
          </Drawer>
          <p className="legal-documents-title">{t('legal_documents')}</p>
        </div>
      }
    </>
  );
};

export default LegalDocumentsNavBar;
